// Sominix theme behavior: gallery thumbnail swap, quantity stepper,
// and before/after comparison sliders.
// Guard against this file being included twice on the same page
// (e.g. both the product section and the before/after section load it).
if (window.__sxScriptsLoaded) {
  // already initialized once — do nothing on subsequent loads
} else {
window.__sxScriptsLoaded = true;
document.addEventListener('DOMContentLoaded', function () {
  // Thumbnail -> hero image swap
  document.querySelectorAll('.sx-product__thumbs').forEach(function (rail) {
    rail.querySelectorAll('.sx-product__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var targetId = thumb.getAttribute('data-target');
        var src = thumb.getAttribute('data-src');
        var target = document.getElementById(targetId);
        if (target && src && target.tagName === 'IMG') {
          target.src = src;
        }
        rail.querySelectorAll('.sx-product__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  // Quantity stepper
  document.querySelectorAll('.sx-product__form').forEach(function (form) {
    var input = form.querySelector('.sx-product__qty-input');
    var decrease = form.querySelector('[data-qty-decrease]');
    var increase = form.querySelector('[data-qty-increase]');
    if (!input) return;

    decrease && decrease.addEventListener('click', function () {
      var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
    });
    increase && increase.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
    });

    // Variant option changes -> update hidden variant id via Shopify's product JSON.
    // Requires the section to also render a `product.json` script tag if you want
    // full client-side variant matching without a page reload. Left as a hook:
    form.querySelectorAll('.sx-product__option-select').forEach(function (select) {
      select.addEventListener('change', function () {
        form.dispatchEvent(new CustomEvent('sx:variant-option-changed'));
      });
    });
  });

  // Bundle / quantity tier cards — clicking a tier switches the hidden
  // variant id (so checkout charges the real price for that variant) and
  // updates the visible price display to match.
  document.querySelectorAll('.sx-tiers').forEach(function (wrap) {
    var tiers = Array.prototype.slice.call(wrap.querySelectorAll('.sx-tier'));
    var form = wrap.closest('form') || wrap.parentElement.querySelector('form');
    var variantInput = form ? form.querySelector('.sx-product__variant-id') : null;
    var buyBox = wrap.closest('.sx-product__buy-box');
    var priceCurrent = buyBox ? buyBox.querySelector('.sx-product__price-current') : null;
    var priceCompare = buyBox ? buyBox.querySelector('.sx-product__price-compare') : null;

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        if (tier.hasAttribute('disabled')) return;
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        var variantId = tier.getAttribute('data-tier-variant-id');
        if (variantInput && variantId) variantInput.value = variantId;
        if (priceCurrent) priceCurrent.textContent = tier.getAttribute('data-tier-price') || priceCurrent.textContent;
        if (priceCompare) {
          var compareText = tier.getAttribute('data-tier-compare');
          if (compareText) {
            priceCompare.textContent = compareText;
            priceCompare.style.display = '';
          } else {
            priceCompare.style.display = 'none';
          }
        }
      });
    });
  });

  // Cross-sell add-on(s) — when checked, adds the add-on product to the cart
  // alongside the main product via Shopify's AJAX Cart API, so the merchant
  // doesn't need a second "Add to Cart" click or a bundling app.
  document.querySelectorAll('.sx-product__form').forEach(function (form) {
    var addonCheckboxes = form.querySelectorAll('.sx-addon__checkbox');
    if (!addonCheckboxes.length) return;

    form.addEventListener('submit', function (e) {
      var checkedAddons = Array.prototype.slice.call(addonCheckboxes).filter(function (cb) { return cb.checked; });
      if (!checkedAddons.length) return; // no add-ons selected — let the normal form submit proceed

      e.preventDefault();
      var variantInput = form.querySelector('.sx-product__variant-id');
      var qtyInput = form.querySelector('.sx-product__qty-input');
      var items = [
        { id: parseInt(variantInput.value, 10), quantity: parseInt((qtyInput && qtyInput.value) || '1', 10) }
      ];
      checkedAddons.forEach(function (cb) {
        var id = parseInt(cb.getAttribute('data-addon-variant-id'), 10);
        if (id) items.push({ id: id, quantity: 1 });
      });

      var submitBtn = form.querySelector('.sx-product__add-btn');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          alert('Sorry, something went wrong adding these items to your cart. Please try again.');
        });
    });
  });

  // Before/After comparison sliders
  document.querySelectorAll('.sx-ba').forEach(function (card) {
    var slider = card.querySelector('.sx-ba__slider');
    var beforeLayer = card.querySelector('.sx-ba__before');
    var handle = card.querySelector('.sx-ba__handle');
    if (!slider || !beforeLayer || !handle) return;

    function update(value) {
      // Clip the "before" layer (which stays full-size) rather than resizing
      // it, so the photo itself never stretches/squishes as the handle moves.
      beforeLayer.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
      handle.style.left = value + '%';
    }

    slider.addEventListener('input', function () {
      update(slider.value);
    });
    // Touch/click anywhere on the image also drags the handle for a nicer feel
    var images = card.querySelector('.sx-ba__images');
    if (images) {
      var isDragging = false;
      var setFromClientX = function (clientX) {
        var rect = images.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        slider.value = pct;
        update(pct);
      };
      images.addEventListener('pointerdown', function (e) {
        isDragging = true;
        setFromClientX(e.clientX);
      });
      window.addEventListener('pointermove', function (e) {
        if (isDragging) setFromClientX(e.clientX);
      });
      window.addEventListener('pointerup', function () {
        isDragging = false;
      });
    }
  });

  // Announcement bar is a pure-CSS scrolling marquee now (see @keyframes
  // sx-marquee in sominix-product.css) — no JS timer/state needed.

  // Countdown urgency banner — counts down from the configured duration,
  // restarting on every page load (see the section's schema info text).
  document.querySelectorAll('[data-sx-countdown]').forEach(function (bar) {
    var display = bar.querySelector('[data-sx-countdown-display]');
    if (!display) return;
    var remaining = parseInt(bar.getAttribute('data-duration-seconds'), 10) || 7200;

    function render() {
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      display.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    render();
    var interval = setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        remaining = 0;
        render();
        clearInterval(interval);
        return;
      }
      render();
    }, 1000);
  });

  // Bundle "Add Bundle to Cart" button — adds every linked item in the
  // bundle to the cart in one AJAX Cart API call, then goes to /cart.
  document.querySelectorAll('[data-sx-bundle-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idsAttr = btn.getAttribute('data-variant-ids') || '';
      var ids = idsAttr.split(',')
        .map(function (s) { return parseInt(s, 10); })
        .filter(function (n) { return n && !isNaN(n); });
      if (!ids.length) return;
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          alert('Sorry, something went wrong adding this bundle to your cart. Please try again.');
        });
    });
  });

  // Quick-add buttons on product row cards. Simple (single-variant) products
  // add straight to cart via the AJAX Cart API; products with real variants
  // let the click fall through to the card's normal link so the shopper can
  // pick options on the product page instead.
  document.querySelectorAll('.sx-row__quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var isSimple = btn.getAttribute('data-quick-add-simple') === 'true';
      if (!isSimple) return; // let the card's <a> handle navigation normally

      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(btn.getAttribute('data-quick-add-variant-id'), 10);
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.textContent = originalText;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          alert('Sorry, something went wrong adding this to your cart. Please try again.');
        });
    });
  });
});
} // end __sxScriptsLoaded guard
